import { createUseParams } from '@provider-portal/common/utils/createUseParams';
import { flattenRoutes } from '@provider-portal/common/utils/flattenRoutes';

/**
 * TODO If you ever change this route, please update `marketing` section in `moduleRoutes` of
 * `app/src/rdx/analytics/applicationRoutes.ts` accordingly
 */

export const routes = flattenRoutes({
  index: '/smart-promotions/regular',
  list: 'list',
  addPromotion: 'add',
  details: {
    index: 'details/:promotionId',
    useParams: createUseParams<{ promotionId?: string }>(),
  },
});

export const smartPromotionRoutes = flattenRoutes({
  index: '/smart-promotions',
  promotions: 'promotions',
  maximizedPromotions: 'promotions/maximized',
  customizedPromotions: 'promotions/customized',
  details: {
    index: 'promotions/details/:promotionId',
    useParams: createUseParams<{ promotionId?: string }>(),
  },
});

export const paidVisibilityRoutes = flattenRoutes({
  index: '/paid-visibility',
  create: {
    index: 'create/:offerId',
    useParams: createUseParams<{ offerId?: string }>(),
  },
  createNew: 'create',
  details: {
    index: 'details/:signupId',
    useParams: createUseParams<{ signupId?: string }>(),
  },
  detail: 'detail',
});
